import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Preloader from '../components/Preloader';
import { API_ENDPOINTS } from '../config/api';

import axios from 'axios';
const url = `${API_ENDPOINTS.MESSAGES}/latest`;
const postUrl = API_ENDPOINTS.MESSAGES;

const Messages = (props) => {
  const { cached, updateCache } = props;
  const [tableMessage, setTableMessage] = useState('Loading data...');
  const [formData, setFormData] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [messages, setMessages] = useState(null);
  const [updated, setUpdated] = useState({
    messages: false,
  });

  useEffect(() => {
    if ( cached.messages ) {
      setMessages(cached.messages);
    } else if (!updated.messages) {
      setUpdated({...updated, messages: true});
      makeRequest('GET');
    }
  }, [JSON.stringify(cached?.messages)]);

  const onChangeHandler = (e) => {
    const { name, value, type, checked } = e.currentTarget;
    const val = type === 'checkbox' ? checked : type === 'select' ? e.target.value : value;

    setFormData({
      ...formData,
      [name]: val,
    });
  }

  const onSubmitHandler = () => {
    if ( formData.id >= 0 || ( messages && messages.id ) ) {
      makeRequest('PUT');
    } else {
      makeRequest('POST');
    }
  }

  const clearFormHandler = () => {
    setFormData({});
  }

  const onDeleteHandler = (id) => {
    if (window.confirm('Do you really want to delete it?')) {
      makeRequest('DELETE', id);
    }
  }

  const makeRequest = (method, id) => {
    setDisabled(true);

    let requestUrl = method === 'GET' ? url : postUrl;
    let message = method === 'POST' ? 'Item is added' : 
                  method === 'PUT' ? 'Item is updated' :
                  method === 'DELETE' ? 'Item is deleted' : null;

    const requestData = {
      method: method,
      signal: AbortSignal.timeout(20000)
    };

    if ( method === 'POST' || method === 'PUT' ) {
      requestData.data = { message: formData.message };
    }

    if ( method === 'DELETE' || method === 'PUT' ) {
      const requestId = id ? id : formData.id ? formData.id : cached.messages.id;

      requestUrl += `/${requestId}`;
    }

    axios(requestUrl, requestData).then((response) => {
      clearFormHandler();

      if ( method === 'GET' ) {
        if ( response.data === '' ) {
          setTableMessage('No messages found.');
        }
        updateCache(response.data);
        setDisabled(false);
      } else {
        makeRequest('GET');
      }

      if ( message ) {
        toast.success(message, {
          position: 'top-right'
        });
      }
    }).catch( (error) => {
      let err = 'Error: ';

      if (error.response) {
        err += error.response.data.errors;
      } else if (error.request) {
        err += 'No response!';
      } else {
        err += error.message;
      }

      setTableMessage(err);

      toast.error(err, {
        position: 'top-right'
      });
      
      setDisabled(false);
    });
  }

  const updating = typeof messages === 'undefined' ? true : false;

  return (
      <div style={{minHeight: 200}} className="container-fluid position-relative">
        { updating ? <Preloader /> : (
          <React.Fragment>
            <h2 className="mt-5">Messages</h2>

            <div className="mt-5">
            <div className="form-group row">
              <div className="col-12 form-group">
                <label className="form-label">Message</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Message"
                  disabled={disabled || updating}
                  name="message"
                  onChange={(e) => onChangeHandler(e)}
                  value={formData.message || ''}
                />
              </div>
            </div>

            <button disabled={disabled || updating} className="btn btn-primary me-2" onClick={() => onSubmitHandler()}>{formData.id >= 0 ? 'Update' : 'Add'}</button>
            <button disabled={disabled || updating} className="btn btn-secondary" onClick={() => clearFormHandler()}>Clear</button>
          </div>     

            <table className="table table-hover mt-5">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col" style={{width: '100%'}}>Message</th>
                  <th scope="col">Updated</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                { messages ? (
                  <tr>
                      <th scope="row">1</th>
                      <td>{messages.message ? messages.message : '-'}</td>
                      <td style={{whiteSpace: 'nowrap'}}>{messages.updated ? messages.updated : '-'}</td>
                      <td style={{whiteSpace: 'nowrap'}}>
                        <button className="btn btn-danger me-1" onClick={() => onDeleteHandler(messages.id)}>Delete</button>
                          <button className="btn btn-primary ms-1" onClick={() => {
                            setFormData({ ...messages });
                            window.scrollTo(0, 0);
                          }}>Edit</button>
                      </td>
                  </tr>
                ) : <tr><td style={{textAlign: 'center', padding: 32}} colSpan="4">{tableMessage}</td></tr> }
              </tbody>
            </table>
          </React.Fragment>
        )}
      </div>
  );
}

export default Messages;
